/* eslint @typescript-eslint/strict-boolean-expressions: off */

import styles from "./TeamProfile.module.css";
import { Avatar } from "gui/avatar/avatar";
import ProfileTitle from "./ProfileTitle";
import TeamStats from "../TeamStats/TeamStats";
import TeamDetails from "./TeamDetails";
import { Member } from "gui/TeamPage/fetchStaticTeamProfileData";
import { StaticTeamProfileData } from "../fetchStaticTeamProfileData";

interface Props {
  team: StaticTeamProfileData;
  dashboardsCount: number;
  queriesCount: number;
  people: Member[];
}

export default function TeamProfile(props: Props) {
  if (!props.team) {
    return null;
  }

  const sectionId = `aria-team-profile`;

  return (
    <section aria-labelledby={sectionId} className={styles.profile}>
      <div className={styles.public}>
        <Avatar src={props.team.profile_image_url || undefined} size={128} />

        <div className={styles["profile-content"]}>
          <ProfileTitle sectionId={sectionId} team={props.team} />
          <TeamDetails team={props.team} people={props.people} />
          <TeamStats
            receivedStarsCount={props.team.received_stars}
            dashboardsCount={props.dashboardsCount}
            queriesCount={props.queriesCount}
            people={props.people}
          />
        </div>
      </div>
    </section>
  );
}
